import { useState } from 'react';
import {
  deviceTitle,
  pointOfSaleLabel,
} from '../../materiels/materielDisplayMaps';
import { friendlyMaterielActionError } from '../../materiels/materielActionErrors';

/**
 * Confirmation Remettre en stock — contrat B2.
 */
export default function MaterielStockConfirmModal({
  open,
  item,
  onClose,
  onConfirm,
}) {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  if (!open || !item) return null;

  const pdv = pointOfSaleLabel(item);

  const requestClose = () => {
    if (submitting) return;
    setError('');
    onClose?.();
  };

  const handleConfirm = async () => {
    if (submitting) return;
    setError('');
    setSubmitting(true);
    try {
      await onConfirm?.();
    } catch (err) {
      setError(
        friendlyMaterielActionError(
          err,
          'Impossible de remettre en stock. Réessayez.'
        )
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center p-4">
      <button
        type="button"
        className="absolute inset-0 bg-black/40"
        aria-label="Fermer"
        disabled={submitting}
        onClick={requestClose}
      />
      <div
        role="dialog"
        aria-modal="true"
        className="relative w-full max-w-sm bg-white rounded-lg shadow-xl border border-gray-200 p-4 space-y-4"
      >
        <h2 className="text-base font-semibold text-gray-900">
          Remettre en stock
        </h2>
        <p className="text-sm text-gray-700 leading-relaxed">
          Retirer <span className="font-medium">{deviceTitle(item)}</span> de{' '}
          <span className="font-medium">{pdv}</span> et le remettre en stock ?
        </p>
        <ul className="text-xs text-gray-600 space-y-1 list-disc list-inside">
          <li>Le matériel n&apos;est pas supprimé.</li>
          <li>Il redevient disponible dans le stock du parc.</li>
        </ul>
        {error ? (
          <p className="text-sm text-red-700" role="alert">
            {error}
          </p>
        ) : null}
        <div className="flex justify-end gap-2">
          <button
            type="button"
            onClick={requestClose}
            disabled={submitting}
            className="px-3 py-2 text-sm text-gray-700 hover:underline"
          >
            Annuler
          </button>
          <button
            type="button"
            onClick={handleConfirm}
            disabled={submitting}
            className="px-3 py-2 text-sm font-medium rounded-md bg-gray-900 text-white hover:bg-gray-800 disabled:opacity-60"
          >
            {submitting ? 'En cours…' : 'Remettre en stock'}
          </button>
        </div>
      </div>
    </div>
  );
}
